import { apiRequest } from './apiClient';

export interface TrackingDetail {
  time: string;
  location: string;
  status: string;
}

export interface TrackingResult {
  available: boolean;
  carrier: string | null;
  trackingNumber: string | null;
  completed?: boolean;
  lastState?: string | null;
  lastUpdatedAt?: string | null;
  trackingDetails?: TrackingDetail[];
}

export function fetchTracking(orderId: string, token: string): Promise<TrackingResult> {
  return apiRequest<TrackingResult>(`/api/orders/${orderId}/tracking`, {
    headers: { Authorization: `Bearer ${token}` },
  });
}
